module.exports = __webpack_public_path__ + "static/airdrielife-logo-2024-5b1e13a2b697f6cddfefd1b019a6d0d7.jpg";